export default {
  field__account_number: '帳號（IBAN）',
  field__document_type: '文件類型',
  field__document_id: '文件ID',
  field__account_holder: '帳戶持有人姓名',
  field__bank_name: '銀行名稱',
  field__bank_code: '銀行代碼',
  field__bank_ifsc_code: '銀行 IFSC 代碼(印度)',
  field__account_holder_address: '帳戶持有人地址',
  field__bank_address: '銀行地址',
  field__bic: 'BIC',
  field__purpose_of_payment: '付款用途',
  field__pay_id: 'PayID',
  field__card_last_four_digits: '卡號後四位',
  field__invoice_receipt_number: '帳單收據編號',
  field__rif: 'RIF',
  field__phone: '電話',
  field__beneficiary: '受益人',
  field__cbu: 'CBU/CVU',
  field__alias: '別名',
};
